import { amex, discover, masterCard, Visa } from 'src/assets/images';

export const getCardImage = (cardType: string) => {
  switch (cardType) {
    case 'visa':
      return Visa;
    case 'american_express':
      return amex;
    case 'discover':
      return discover;
    case 'mastercard':
      return masterCard;
    default:
      return Visa;
  }
};

export const maskCardNumber = (cardNumber: string): string => {
  if (!cardNumber) return '';
  const last4 = cardNumber.slice(-4);
  return `XXXX-XXXX-XXXX-${last4}`;
};

export const formatExpiryDate = (expiryDate: string): string => {
  if (!expiryDate) return '';
  return `Expires: ${expiryDate}`;
};
